<template>
  <div id="invoice">
    <div v-if="client" class="client">
      <div class="company">{{ client.company }}</div>
      <div v-if="client.with_regards_to" class="attn">
        tav. {{ client.with_regards_to }}
      </div>
      <div class="address">
        <div class="street">
          {{ client.street }} {{ client.house_number }}
        </div>
        <div class="city">{{ client.postal_code }} {{ client.city }}</div>
        <div class="vat">{{ client.VAT }}</div>
      </div>
    </div>
    <div class="content">
      <div class="detail">
        <div class="invoice-number">
          <div class="title">FACTUUR</div>
          <div class="number">N° {{ invoice.number }}</div>
        </div>
        <div class="dates">
          <div class="date">
            <label>Factuur datum</label>
            <div class="value">{{ moment(invoice.date).format("DD / MM / YYYY") }}</div>
          </div>
          <div class="date" v-if="invoice.paymentCondition !== 'payed'">
            <label>Verval datum</label>
            <div class="value">{{ moment(invoice.date).add(invoice.payment_period, "d").format("DD / MM / YYYY")}}</div>
          </div>
        </div>
    </div>
      <div v-if="invoice.title" class="general-title">{{ invoice.title }}</div>
      <div v-if="invoice.articles" class="articles">
        <div class="article-layout legend">
          <div v-if="showDate" class="legend-item date">Date</div>
          <div class="legend-item description">Voor de levering van</div>
          <div class="legend-item price-unit">PP</div>
          <div class="legend-item quantity">Aantal</div>
          <div class="legend-item price">Prijs</div>
        </div>
        <div
          class="article-layout article"
          v-for="(article, index) of invoice.articles"
          :key="index"
        >
          <div v-if="moment(article.date).isValid()" class="date">
            {{ moment(article.date).format("YYYY / MM / DD") }}
          </div>
          <div class="article-item description">
            <div class="desc-1">{{ article.description }}</div>
            <div class="desc-2">{{ article.sub_description }}</div>
            <div class="desc-3">{{ article.third_description }}</div>
          </div>
          <div class="article-item price-unit">{{ article.price_unit }}</div>
          <div class="article-item quantity">{{ article.quantity }}</div>
          <div class="article-item price">
            {{ calculateArticleTotal(article) }}
          </div>
        </div>
      </div>
      <div class="payment-condition" v-if="invoice.paymentCondition === 'payed'">
        Betalingvoorwaarde: <b>VOLDAAN</b>
      </div>
      <div class="totals">
        <div v-if="invoice.discount > 0" class="totals-item discount">
          <div class="label">{{ invoice.discount }}% discount</div>
          <div class="value">-{{ discount() }}</div>
        </div>
        <div class="totals-item sub-total">
          <div class="label">Subtotal</div>
          <div class="value">{{ subTotal() }}</div>
        </div>
        <div class="totals-item vat-percentage">
          <div class="label">{{ invoice.vat_percentage }}% VAT</div>
          <div class="value">{{ vat() }}</div>
        </div>
        <div class="totals-item total">
          <div class="label">Total</div>
          <div class="value">{{ total() }}</div>
        </div>
      </div>
      <div class="own">
        <div class="own-group">
          <div class="own-item street">{{ company.street }} {{ company.houseNumber }}</div>
          <div class="own-item city">{{ company.postalCode }} {{ company.city }}</div>
          <div class="own-item email">{{ company.phone }}</div>
          <div class="own-item email">{{ company.email }}</div>
          <div class="own-item website">{{ company.website }}</div>
        </div>
        <div class="own-group">
          <div class="own-item vat">BTW {{ company.vat }}</div>
          <div class="own-item account">IBAN {{ company.account }}</div>
          <div class="own-item legal">{{ company.legal}} </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "bonos-template-v1",
  props: ["invoice", "client", "user", "company", "url"],
  data() {
    return {
      moment: moment,
      subTotalWithoutDiscount() {
        let subTotal = 0;
        for (let article of this.invoice.articles) {
          subTotal += article.price_unit * article.quantity;
        }
        return +(Math.round(subTotal + "e+2") + "e-2");
      },
      discount() {
        if (this.invoice.discount) {
          return (this.subTotalWithoutDiscount() / 100) * this.invoice.discount;
        }
        return 0;
      },
      subTotal() {
        let subTotal = 0;
        if(this.invoice.articles){
          for (let article of this.invoice.articles) {
            subTotal += article.price_unit * article.quantity;
          }
        }
        return +(Math.round(subTotal - this.discount() + "e+2") + "e-2");
      },
      vat() {
        let vat = (this.subTotal() / 100) * this.invoice.vat_percentage;
        return +(Math.round(vat + "e+2") + "e-2");
      },
      total() {
        let total = this.subTotal() + this.vat();
        return +(Math.round(total + "e+2") + "e-2");
      },
    };
  },
  computed: {
    showDate() {
      for (let article of this.invoice.articles) {
        if (moment(article.date).isValid()){
          return true
        }
      }
      return false;
    }
  },
  methods: {
    calculateArticleTotal(article) {
      let articleTotal = article.price_unit * article.quantity;
      return +(Math.round(articleTotal + "e+2") + "e-2");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
#invoice {
  position: relative;

  .client {
    position: absolute;
    right: 140px;
    top: 200px;
    font-size: 14px;
    .company {
      font-size: 16px;
      font-weight: 700;
    }
    .address {
    }
  }
  .own {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 20px;
    font-size: 14px;
    text-align: center;
    .own-group {
      margin: 0 60px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }
    .own-item {
      &:after {
        padding: 0 8px;
        content: "-";
      }
      &:last-of-type {
        &:after {
          padding: 0;
          content: none;
        }
      }
    }
    .legal {
    }
  }

  .content {
    padding-top: 380px;
    display: flex;
    flex-direction: column;
  }

  .detail {
    margin: 0 auto 40px;
    .invoice-number {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        font-size: 20px;
        margin-right: 5px;
      }
      .number {
        font-weight: 500;
        font-size: 20px;
      }
    }
    .dates {
      margin-top: 10px;
      .date {
        display: flex;
        align-items: center;
        label {
          font-size: 10px;
          margin-right: 10px;
        }
        .value {
          font-size: 12px;
        }
      }
    }
  }

  .general-title {
    width: 100%;
    background: rgba(var(--color-invoice-theme-values), 0.6);
    text-align: center;
    padding: 5px 0;
    margin: 10px 0;
    font-size: 14px;
    font-weight: 700;
  }

  .articles {
    padding: 10px 80px;
    width: 21cm;
    box-sizing: border-box;
    .legend {
      margin-bottom: 20px;
    }
  }

  .discount {
    display: flex;
    align-items: center;
    .value {
      padding: 3px;
    }
  }

  .payment-condition {
    position: absolute;
    left: 80px;
    bottom: 140px;
    b {
      padding-left: 10px;
      color: var(--color-invoice-theme);
    }

  }

  .totals {
    right: 80px;
    bottom: 140px;
    position: absolute;
    .totals-item {
      text-align: right;
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        width: 90px;
        margin-right: 5px;
      }
      .value {
        font-size: 14px;
        padding: 3px;
        text-align: right;
        width: 100px;
        &:after {
          content: "EUR";
          font-size: 10px;
          margin-left: 5px;

        }
      }
    }
    .discount {
      margin-bottom: 20px;
      color: var(--color-invoice-theme);

    }
    .total {
      margin-top: 10px;
      .value {
        font-size: 16px;
        font-weight: 700;
        color: var(--color-invoice-theme);
      }
    }
  }
}
.invoice-image-template {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.article {
  margin-top: 5px;
}

.article-layout {
  display: flex;
  width: 100%;
  .article-item {
    font-size: 16px;
    font-weight: 400;
  }
  .legend-item {
    font-size: 12px;
    font-weight: 700;
  }
  .date {
    font-size: 14px;
    width: 100px;
  }
  .description {
    flex-grow: 1;
    .desc-2 {
      font-size: 14px;
    }
    .desc-3 {
      font-size: 12px;
      font-weight: 700;
    }
  }
  .unit {
    width: 50px;
    text-align: center;
  }
  .price-unit {
    width: 75px;
    text-align: center;
  }
  .quantity {
    text-align: center;
    width: 60px;
  }
  .price {
    text-align: right;
    width: 75px;
  }
}

@media print {
  #invoice-template {
    border: none;
  }
}

</style>
